export const SITE_NAME = 'AllChinaBuy Spreadsheet';

export const LAST_MODIFIED = '2026-08-24';

export const FAVICON_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/14bc629c50c04cb08f38590896596985.jpeg';

export function getSiteUrl(): string {
  const envUrl = import.meta.env.VITE_SITE_URL as string | undefined;
  if (envUrl) return envUrl.replace(/\/+$/, '');
  return typeof window !== 'undefined' ? window.location.origin : '';
}